import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import { StyledContainer, StyledSection } from './JuniorsWhy.styled';

const JuniorsWhy: React.FC = () => {
  const { t } = useI18n('helping-juniors');

  return (
    <StyledSection>
      <StyledContainer>
        <img
          src={getPublicPath(`/images/helpingJuniors/why.svg`)}
          alt=""
          role="presentation"
        />
        <div>
          <Heading2 editorial alignLeft>
            {t('helping-juniors.why.title')}
          </Heading2>
          <div>
            <HtmlTrans
              ns={'helping-juniors'}
              i18nKey={'helping-juniors.why.desc'}
            ></HtmlTrans>
          </div>
        </div>
      </StyledContainer>
    </StyledSection>
  );
};

export default JuniorsWhy;
